import { UseIsMobile } from 'common/hooks/UseIsMobile';
import { DesktopForceChangePassword } from './desktop';
import { MobileForceChangePassword } from './mobile';

function ForceChangePassword() {
  const mobile = UseIsMobile()

  return (
    <div>
      {
        mobile ?
          <div className="md:hidden">
            <MobileForceChangePassword />
          </div>
          :
          <div className="hidden md:block">
            <DesktopForceChangePassword />
          </div>
      }
    </div>
  );
}

export default ForceChangePassword;
